(function() {
    'use strict';
    angular
        .module('jmrsignApp')
        .factory('Document', Document);

    Document.$inject = ['$resource', 'DateUtils'];

    function Document ($resource, DateUtils) {
        var resourceUrl =  'api/documents/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                        data.expireDate = DateUtils.convertDateTimeFromServer(data.expireDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
